import './DownloadBar.scss';

import { ReactComponent as Document } from '../../images/icons/menu/Document.svg';
import { ReactComponent as Download } from '../../images/icons/Download.svg';
import Paragraph from 'components/TextComps/Paragraph';
import Subtitle from 'components/TextComps/Subtitle';

type Props = {
  subtitle: string;
  description: string;
  iconSubtitle: string;
  onClick: () => void;
};

const DownloadBar = ({ subtitle, description, iconSubtitle, onClick }: Props) => {
  return (
    <div className='download-bar-container'>
      <div className='icon document'>
        <Document />
        <p>{iconSubtitle}</p>
      </div>
      <div className='text'>
        <Subtitle>
          <>{subtitle}</>
        </Subtitle>
        <Paragraph>
          <>{description}</>
        </Paragraph>
      </div>
      <span className='icon download' onClick={onClick}>
        <Download />
      </span>
    </div>
  );
};

export default DownloadBar;
